import { proxy } from "valtio";
import { useSnapshot } from "valtio/react";

interface SearchFormClientState {
  is_expanded: boolean;
}

const search_form_compact_state = proxy<SearchFormClientState>({
  is_expanded: false
});

export const useIsSearchFormExpanded = (): boolean => {
  return useSnapshot(search_form_compact_state).is_expanded;
};

export const setIsSearchFormExpanded = (is_expanded: boolean): void => {
  if (typeof window === "undefined") {
    throw new Error(
      "setIsSearchFormExpanded should only be used on the client side"
    );
  }
  search_form_compact_state.is_expanded = is_expanded;
};
